import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
import * as types from './mutation-types'
// import * as mutations from 'mutations'

import app from './modules/app'
import menu from './modules/menu'
import schedule from './modules/schedule'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: true,  // process.env.NODE_ENV !== 'production',
  actions,
  getters,
  modules: {
    app,
    menu,
    schedule
  },
  state: {
    customer: '',
    auth: {
      isLogged: false,
      token: '',
      user: {
        username: '',
        id: '',
        client: {},
        clientId: '',
        name: '',
        healthInsurance: null,
        code: '',
        numberMedicalRecord: null,
        profile: {}
      }
    },
    recoveryPassword: {
      token: ''
    }
  },
  mutations: {
    [types.AUTH] (store, obj) {
      store.auth = obj
    },
    [types.CUSTOMER] (store, obj) {
      store.customer = obj
    },
    [types.RECOVERY_PASSWORD] (store, obj) {
      store.recoveryPassword.token = obj
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js